// react
import PropTypes from "prop-types";
import React, { useRef } from "react";

import { createInputId } from "../../../hooks/useInputId";

// components
import InputWrapper from "../../Inputs/InputWrapper";
// style
import css from "./LongText.module.scss";

const LongText = ({
	disabled = false,
	onChange = () => {},
	onKeyDown = () => {},
	onBlur = () => {},
	onFocus = () => {},
	onKeyUp = () => {},
	placeholder = "",
	name = "",
	className = "",
	style = {},
	value = "",
	label = "",
	testId,
	titleHref,
	inputTooltip,
	inputId = createInputId(),
}) => {
	const inputRef = useRef(null);

	const focus = () => {
		inputRef.current?.focus();
	};

	const handleChange = (e) => {
		onChange(e.target.value);
	};

	const handleFocus = () => {
		onFocus();
	};

	const handleBlur = () => {
		onBlur();
	};

	const handleKeyDown = (e) => {
		onKeyDown(e.key);
	};

	const handleKeyUp = (e) => {
		onKeyUp(e.key);
	};

	return (
		<InputWrapper
			label={label}
			inputId={inputId}
			titleHref={titleHref}
			disabled={disabled}
			titleTooltip={inputTooltip}
		>
			<textarea
				ref={inputRef}
				id={inputId}
				className={`react-input ${className} ${css.textareaInput}`}
				value={value}
				name={name}
				disabled={disabled}
				onBlur={handleBlur}
				onFocus={handleFocus}
				onChange={handleChange}
				placeholder={placeholder}
				onKeyUp={handleKeyUp}
				onKeyDown={handleKeyDown}
				style={{ borderBox: "box-sizing", width: "100%", ...style }}
				data-testid={testId}
			/>
		</InputWrapper>
	);
};

LongText.propTypes = {
	disabled: PropTypes.bool,
	onChange: PropTypes.func,
	onKeyDown: PropTypes.func,
	onBlur: PropTypes.func,
	onFocus: PropTypes.func,
	onKeyUp: PropTypes.func,
	placeholder: PropTypes.string,
	name: PropTypes.string,
	className: PropTypes.string,
	style: PropTypes.object,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	label: PropTypes.string,
	testId: PropTypes.string,
	titleHref: PropTypes.string,
	inputTooltip: PropTypes.string,
};

export default LongText;
